import { render, staticRenderFns } from "./Bulletin.vue?vue&type=template&id=dc395a56&scoped=true"
import script from "./Bulletin.vue?vue&type=script&lang=js"
export * from "./Bulletin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc395a56",
  null
  
)

export default component.exports